import { Navigate, Route, Routes } from 'react-router-dom';
import { CountryDashboard } from 'pages/insights-pro/country-tab/CountryDashboard';
import { CountryChannelBreakdown } from 'pages/insights-pro/country-tab/reports/country-channel-breakdown/CountryChannelBreakdown';
import { CountriesOverTimeReport } from 'pages/insights-pro/country-tab/reports/countries-over-time/CountriesOverTimeReport';

export function CountryRoutes() {
  return (
    <Routes>
      <Route index element={<CountryDashboard />} />
      <Route path="reports/channel-breakdown" element={<CountryChannelBreakdown />} />
      <Route path="reports/over-time" element={<CountriesOverTimeReport />} />
      <Route path="*" element={<Navigate to="" />} />
    </Routes>
  );
}
